export const FETCH_FLEXTRACK_PAST_DUE_PERIODS_REQUEST = 'FETCH_FLEXTRACK_PAST_DUE_PERIODS_REQUEST';
export const FETCH_FLEXTRACK_PAST_DUE_PERIODS_SUCCESS = 'FETCH_FLEXTRACK_PAST_DUE_PERIODS_SUCCESS';
export const FETCH_FLEXTRACK_PAST_DUE_PERIODS_FAILURE = 'FETCH_FLEXTRACK_PAST_DUE_PERIODS_FAILURE';
